import { IGetObraAreaDropDownUseCase } from "../../../presentation/useCases/read/get_obra_area_drop_down_use_case";
import { ObraAreaDropDown } from "../../models/obra_area_dropdown";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * GetObraAreaDropDownUseCase
 */

export class GetObraAreaDropDownUseCase implements IGetObraAreaDropDownUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async getObraAreaDropDown(
    idObra: number,
  ): Promise<ObraAreaDropDown[]> {
    return await this.repository.getObraAreaDropDown(idObra);
  }
}
